"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const zod_1 = require("zod");
const manifest_1 = require("../manifest");
const _appearance_1 = require("./_appearance");
const _heading_1 = require("./_heading");
(0, manifest_1.registerSection)({
    type: 'testimonials', label: 'Testimonials', icon: 'quote', category: 'content',
    settingsSchema: zod_1.z.object({
        title: zod_1.z.string().max(120).default('What customers say'),
        ..._heading_1.headingShape,
        ..._appearance_1.appearanceShape,
    }),
    blockTypes: { quote: { label: 'Quote', icon: 'quote',
            settingsSchema: zod_1.z.object({
                quote: zod_1.z.string().max(500).default(''),
                author: zod_1.z.string().max(120).default(''),
                role: zod_1.z.string().max(120).default(''),
            }) } },
    maxBlocks: 12,
    defaults: () => ({ title: 'What customers say', ...(0, _heading_1.headingDefaults)(), ...(0, _appearance_1.appearanceDefaults)() }),
    fields: [
        { name: 'title', label: 'Heading', control: 'text', group: 'Content' },
        ..._heading_1.headingFields,
        ..._appearance_1.appearanceFields,
    ],
    blockFields: {
        quote: [
            { name: 'quote', label: 'Quote', control: 'textarea' },
            { name: 'author', label: 'Author', control: 'text' },
            { name: 'role', label: 'Role / location', control: 'text' },
        ],
    },
});
//# sourceMappingURL=testimonials.js.map